module.exports = __webpack_public_path__ + "ca.svg?dc990421780e848dd0c3a57d5c00188e";